var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoadingInfinite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2000 -1000 4000 2000"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@keyframes infinite-ani{0%{stroke-dashoffset:6713}to{stroke-dashoffset:0}}.loading_infinite_svg__path{fill:none;stroke-width:6%;stroke-linecap:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "loading_infinite_svg__path",
    d: "M354-354a500 500 0 110 708l-708-708a500 500 0 100 708z",
    stroke: "#000",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    className: "loading_infinite_svg__path",
    d: "M354-354a500 500 0 110 708l-708-708a500 500 0 100 708z",
    style: {
      animationName: "infinite-ani",
      animationDuration: "1s",
      animationIterationCount: "infinite",
      animationTimingFunction: "cubic-bezier(.3,.65,.55,.15)"
    },
    stroke: "#fff",
    strokeDasharray: "1570 5143"
  }));
}

export default SvgLoadingInfinite;